import React from "react";
import Drawer from "@material-ui/core/Drawer";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import ActionChatRoom from "../../actions/actionCompDrawer";
import swal from "@sweetalert/with-react";
import GlobalApi from "../../../Global";
import refresh_token from "../../../Global/refresh_token";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

export default function SwipeableTemporaryDrawer({ toggleAction, state }) {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  let currentCompany = useSelector((state) => state.companyReducer.company);
 
  function getFileSize() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      user_id: data.user_id,
      organization_id:data?.organization_id
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/ConfigFileSize/get_all_file_sizes_user?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          console.log(response.data);
          dispatch({ type: "SET_FILE_SIZE", payload: response.data });
          // setCurrentFileSize(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getFileSize();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }


  async function handleDelete() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;

    swal({
      title: t("Are you sure?"),
      text: t("All Data Including Media will be permenantly Deleted!"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {

      console.log(state);
      if (isConfirm) {
        try {
          let res = await fetch(GlobalApi + "/Action/edit_action", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              company_id:currentCompany.id,
              action_id: state.id,
              ["isDeleted"]: true,
            }),
          });
      
          let resJson = await res.json();
          getFileSize();
          toggleAction()

        } catch (err) {
          console.log(err);
        }
      } else {
        console.log("Canceled");
      }
    });    
  }
  return (
    <React.Fragment>
      <Drawer
        anchor={"right"}
        open={state}
        onClose={toggleAction}
        onOpen={toggleAction}
      >
        <Container>
          <Grid container spacing={0} style={{ padding: 5 }}>
            <Grid item xs={6} align="left">
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
                size="small"
                onClick={() => toggleAction()}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
            <Grid item xs={6} align="right">
              <Button
                variant="outlined"
                color="secondary"
                className="deleteBtn"
                onClick={() => handleDelete()}
              >
                Delete
              </Button>
            </Grid>
          </Grid>
        </Container>
        <Divider />
        <Container>
          <Grid container spacing={0} style={{ padding: 5 }}>
            <Grid item xs={12} align="left">
              {/* <ActionChatRoom id={state.id} /> */}
            </Grid>
          </Grid>
        </Container>
      </Drawer>
    </React.Fragment>
  );
}
